import { apiPath } from '../../constants';
import {
    axios,
    apiRequestOptions,
    errorRequestHandler,
    transformHttpResponse,
} from 'utils';

export const COMPETITIONS_CATEGORY_REQUEST = 'FETCH_COMPETITIONS_CATEGORY_REQUEST';
export const COMPETITIONS_CATEGORY_FAILURE = 'FETCH_COMPETITIONS_CATEGORY_FAILURE';
export const COMPETITIONS_CATEGORY_SUCCESS = 'FETCH_COMPETITIONS_CATEGORY_SUCCESS';

export const fetchCompetitionCategories = (competition) => {
    return function(dispatch) {
        dispatch(fetchCompetitionsRequest());
        return axios(apiRequestOptions(apiPath.COMPETITION_CATEGORY.LIST, {competition}))
            .then(transformHttpResponse)
            .then(response => dispatch(fetchCompetitionsSuccess(response.data, competition)))
            .catch(error => transformHttpResponse(error.response))
            .catch(error => {
                dispatch(fetchCompetitionsFailure(error));
                dispatch(errorRequestHandler(error));
            });
    }
};

const fetchCompetitionsRequest = () => ({type: COMPETITIONS_CATEGORY_REQUEST})
const fetchCompetitionsFailure = error => ({type: COMPETITIONS_CATEGORY_FAILURE, error})
const fetchCompetitionsSuccess = (data, competition) => ({type: COMPETITIONS_CATEGORY_SUCCESS, data, competition})
